/// <reference path="app/BaseFramework/core/prototypes/global.d.ts" />

import "app/BaseFramework/core/prototypes/prototypes"
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { GlobalAppModule } from './app/global-app.module';
import { environment } from './environments/environment';

// if (environment.production) {
//   enableProdMode();
//   window.console.log = function () { }
// }

platformBrowserDynamic().bootstrapModule(GlobalAppModule)
  .catch(err => console.error(err));
